import styled from "styled-components";

export const Container = styled.div`
  ${(props) => `
    background-color: ${props.theme.colors.white};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  align-items: flex-start;
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  font-size: 1.4rem;
  height: 100vh;
  padding: 0 5rem 5rem 5rem;
  width: 42rem;
`;

export const VolanteInfo = styled.div`
  font-size: 1.8rem;
  padding-top: 6rem;
  padding-bottom: 2rem;
  width: 100%;

  p {
    margin: 0;
  }

  .quotation-id {
    color: ${(props) => props.theme.colors.primaryBlue};
    font-weight: 600;
  }

  .importer-name {
    font-weight: 800;
    margin-top: 0.5rem;
    margin-bottom: 1.2rem;
  }
`;

export const StatusInfo = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  font-weight: 500;
  overflow-y: scroll;
  scrollbar-width: none;
  width: 100%;

  -ms-overflow-style: none;
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const StatusCard = styled.div`
  ${(props) => `
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  align-items: flex-start;
  border-radius: 8px;
  box-shadow: 0px 5px 50px rgb(231 231 234 / 62%);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  font-size: 1.2rem;
  height: 100%;
  margin-bottom: 1.2rem;
  padding: 1rem 1.5rem;
  width: 100%;

  p {
    font-family: ${(props) => props.theme.fontFamilies.primaryFont};
    font-size: 1.4rem;
    font-weight: 500;
  }
`;

export const CloseButton = styled.button`
  all: unset;
  cursor: pointer;
  margin-left: 38rem;
  margin-top: -2rem;
  top: 0;
  zoom: 1.1;
`;

export const PMessage = styled.p`
  text-align: justify;
`;
